import script from "./RejectPaymentModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./RejectPaymentModal.vue?vue&type=script&setup=true&lang=ts"

import "./RejectPaymentModal.vue?vue&type=style&index=0&id=2079f281&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2079f281"]])

export default __exports__